export const VOICE_SETTINGS_KEY = "a2zVoiceSettings";

export const VOICE_COMMANDS = {
  OPEN: "open",
  SHOW: "show",
  ADD: "add",
  REMOVE: "remove",
  TABLE: "table",
};

export const DEFAULT_VOICE_COMMANDS = {
  [VOICE_COMMANDS.OPEN]: [VOICE_COMMANDS.OPEN],
  [VOICE_COMMANDS.SHOW]: [VOICE_COMMANDS.SHOW],
  [VOICE_COMMANDS.TABLE]: [VOICE_COMMANDS.TABLE],
  [VOICE_COMMANDS.ADD]: [VOICE_COMMANDS.ADD],
  [VOICE_COMMANDS.REMOVE]: [VOICE_COMMANDS.REMOVE],
};

export const VOICE_COMMAND_KEYS = Object.keys(DEFAULT_VOICE_COMMANDS);

export const VOICE_COMMAND_HELP = {
  [VOICE_COMMANDS.OPEN]: [{ example: "open 10122", action: "Will open the Bill-10122 when one matching bill is found." },
    { example: "open Book Table", action: "Will open the Book table & u can select" },
    { example: "open Take Away", action: "Will open the new bill forTake Away"}
  ],
  [VOICE_COMMANDS.SHOW]: [{ example: "show customer", action: "Shows the named item in supported screens." }],
  [VOICE_COMMANDS.TABLE]: [{ example: "table 1", action: "Will open the table-1 when one matching table is found." },
    { example: "table 2", action: "Will open the table-2 when one matching table is found." },
  ],
  [VOICE_COMMANDS.ADD]: [{ example: "add item", action: "Adds or creates the named item in supported screens." }],
  [VOICE_COMMANDS.REMOVE]: [{ example: "remove item", action: "Removes the named item in supported screens." }],
};

export const DEFAULT_VOICE_SETTINGS = {
  enabled: true,
  listenDurationMs: 7000,
  speechThreshold: 0.025,
  speechStartDelay: 120,
  speechEndDelay: 700,
  commands: DEFAULT_VOICE_COMMANDS,
};

export function normalizeVoiceSettings(settings = {}) {
  const usedSynonyms = new Set(Object.keys(DEFAULT_VOICE_COMMANDS));
  const commands = Object.keys(DEFAULT_VOICE_COMMANDS).reduce((result, command) => {
    const synonyms = settings.commands?.[command];
    const configuredSynonyms = Array.isArray(synonyms) && synonyms.length
      ? synonyms.filter(Boolean).map((value) => String(value).trim()).filter(Boolean)
      : DEFAULT_VOICE_COMMANDS[command];
    const uniqueSynonyms = configuredSynonyms.filter((synonym) => {
      const normalized = synonym.toLowerCase();
      if (usedSynonyms.has(normalized)) return false;
      usedSynonyms.add(normalized);
      return true;
    });
    // The original command must always remain available to existing handlers.
    result[command] = [command, ...uniqueSynonyms];
    return result;
  }, {});

  return {
    ...DEFAULT_VOICE_SETTINGS,
    ...settings,
    commands,
  };
}
